import { render, staticRenderFns } from "./ScormFramePlayer.vue?vue&type=template&id=4073ca6e&scoped=true&"
import script from "./ScormFramePlayer.vue?vue&type=script&lang=js&"
export * from "./ScormFramePlayer.vue?vue&type=script&lang=js&"
import style0 from "./ScormFramePlayer.vue?vue&type=style&index=0&id=4073ca6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4073ca6e",
  null
  
)

export default component.exports